import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VNavBarComponent } from '@directives/_core/v-nav-bar/v-nav-bar.component';
import { VNavItemComponent } from '@directives/_core/v-nav-bar/v-nav-item/v-nav-item.component';
import { PipesModule } from 'src/app/_pipes/_pipes.module';
import { BindCssVariableDirective } from "./bind-css-variable/bind-css-variable.directive";
import { ScrollShadowDirective } from "./scroll-shadow/scroll-shadow.directive";
import { VButtonComponent } from "./v-button/v-button.component";
import { VButtonDropdownComponent } from "./v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { VDropdownComponent } from "./v-dropdown/v-dropdown.component";
import { VItemDropdownComponent } from "./v-dropdown/v-item-dropdown/v-item-dropdown.component";
import { VTilesComponent } from './v-tiles/v-tiles.component';
import { VTileComponent } from './v-tiles/v-tile.component';
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { SkeletonLoaderComponent } from "./skeleton-loader/skeleton-loader.component";
import { VPopupComponent } from './v-popup/v-popup.component';

const privateComponents: any[] = [
];

const publicComponents: any[] = [

    VDropdownComponent,
    VItemDropdownComponent,

    VButtonComponent,
    VButtonDropdownComponent,
    VNavBarComponent,
    VNavItemComponent,
    VTilesComponent,
    VTileComponent,

    SkeletonLoaderComponent,
    VPopupComponent
];

const declarations: any[] = [
    BindCssVariableDirective,
    ScrollShadowDirective
];

@NgModule({
    providers: [
    ],
    imports: [
        CommonModule,
        PipesModule,
        OverlayModule,
        PortalModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class CoreDirectivesModule {
    constructor() {
    }
}
